import type React from 'react'

import { PaymentsSkeleton, PlanCardSkeleton, StatsSkeleton } from './components'
import css from './styles.module.css'

export const SubscriptionSkeleton: React.FC = () => {
  return (
    <div className={css.subscription_skeleton}>
      <h1 className={css.header}>Subscription</h1>
      <PlanCardSkeleton />
      <StatsSkeleton />
      <PaymentsSkeleton />
    </div>
  )
}
